const addClass = (element, theClass) => {
  element.classList.add(theClass);
}

const removeClass = (element, theClass) => {
  element.classList.remove(theClass);
}

const showMore = (element, excerpt) => {
  element.addEventListener("click", event => {
    const showText = 'Xem thêm chi tiết >>'
    const hideText = 'Thu gọn'
    const linkText = event.target.textContent
    const label = element.querySelector('.js-label')
    event.preventDefault();

    if (linkText === showText) {
      label.textContent = hideText

      removeClass(excerpt, "excerpt-hidden")
      addClass(excerpt, "excerpt-visible")
    } else {
      label.textContent = showText

      removeClass(excerpt, "excerpt-visible")
      addClass(excerpt, "excerpt-hidden")
    }
  })
}

export default () => {
  const showMoreLinks = document.querySelectorAll('.js-show-more')

  showMoreLinks.forEach(function(link) {
    const excerpt = link.previousElementSibling.querySelector('.js-excerpt')
    showMore(link, excerpt)
  });
}
